export function setOpenSideMenu(payload: boolean) {
  return {
    type: 'OPEN_SIDE_MENU',
    payload,
  };
}

export function setFileSend(payload: boolean) {
  return {
    type: 'SET_FILE_SEND',
    payload,
  };
}
